import ScrollReveal from '../../../components/feature/ScrollReveal';

export default function Venue() {
  return (
    <section className="relative py-16 sm:py-32 px-4 sm:px-6" style={{ background: '#FDFAF4' }}>
      <div className="relative z-10 max-w-7xl mx-auto">

        <ScrollReveal direction="up">
          <div className="text-center mb-12 sm:mb-20 space-y-3">
            <h2 className="text-4xl sm:text-6xl md:text-7xl font-serif italic text-[#2A1A14] leading-tight">
              Места проведения
            </h2>
            <div className="flex items-center gap-3 justify-center pt-1">
              <div className="h-px w-12 bg-[#A8323C]/50" />
              <span className="text-[#A8323C] text-sm">✦</span>
              <div className="h-px w-12 bg-[#A8323C]/50" />
            </div>
          </div>
        </ScrollReveal>

        <div className="grid lg:grid-cols-2 gap-10 sm:gap-16">
          {/* ЗАГС */}
          <ScrollReveal direction="left" delay={100}>
            <div className="group relative">
              {/* Photo with vintage treatment */}
              <div className="relative mb-6 sm:mb-8">
                <div className="absolute inset-0 translate-x-2 translate-y-2 border border-[#A8323C]/15 bg-[#E8DDD0]" />
                <div className="relative aspect-[4/3] overflow-hidden border border-[#A8323C]/30">
                  <img
                    src="/images/mitino.jpeg"  
                    alt="Митинский ЗАГС"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    style={{ filter: 'sepia(0.2) contrast(1.05) brightness(0.97)' }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2A1A14]/20 to-transparent pointer-events-none" />
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center border border-[#A8323C]/50 text-[#A8323C] font-serif italic text-sm bg-[#FDFAF4]">1</div>
                  <p className="text-xs tracking-[0.25em] uppercase text-[#8B6B5A] font-mono">Церемония</p>
                </div>
                <h3 className="text-2xl sm:text-3xl font-serif italic text-[#2A1A14]">Митинский ЗАГС</h3>
                <div className="h-px w-10 bg-[#A8323C]/40" />
                <p className="text-base text-[#6B5040] leading-relaxed">
                  Москва, Дубравная улица, 48А
                </p>
                <p className="text-sm text-[#8B6B5A] leading-relaxed">
                  Торжественная регистрация брака.<br />
                  Сбор гостей в 16:45, роспись в 17:00.
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* Ресторан Турандот */}
          <ScrollReveal direction="right" delay={250}>
            <div className="group relative">
              <div className="relative mb-6 sm:mb-8">
                <div className="absolute inset-0 translate-x-2 translate-y-2 border border-[#A8323C]/15 bg-[#E8DDD0]" />
                <div className="relative aspect-[4/3] overflow-hidden border border-[#A8323C]/30">
                  <img
                    src="/images/tur.jpeg"
                    alt="Ресторан Турандот"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    style={{ filter: 'sepia(0.2) contrast(1.05) brightness(0.97)' }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2A1A14]/20 to-transparent pointer-events-none" />
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center border border-[#A8323C]/50 text-[#A8323C] font-serif italic text-sm bg-[#FDFAF4]">2</div>
                  <p className="text-xs tracking-[0.25em] uppercase text-[#8B6B5A] font-mono">Банкет</p>
                </div>
                <h3 className="text-2xl sm:text-3xl font-serif italic text-[#2A1A14]">Ресторан «Турандот»</h3>
                <div className="h-px w-10 bg-[#A8323C]/40" />
                <p className="text-base text-[#6B5040] leading-relaxed">
                  Москва, Тверской бульвар, д. 26
                </p>
                <p className="text-sm text-[#8B6B5A] leading-relaxed">
                  Праздничный ужин.<br />
                  Начало в 19:00, завершение в 00:00.
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal direction="up" delay={150}>
          <div className="flex justify-center mt-12 sm:mt-20">
            <a
              href="https://yandex.ru/maps/213/moscow/?indoorLevel=1&ll=37.348302%2C55.840649&mode=routes&rtext=~55.840649%2C37.348302&rtt=mt&ruri=~ymapsbm1%3A%2F%2Forg%3Foid%3D38839858297&z=17"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 px-7 sm:px-10 py-3 sm:py-4
                         border border-[#A8323C] text-[#A8323C] bg-transparent
                         hover:bg-[#A8323C] hover:text-white
                         transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ outline: '1px solid rgba(168,50,60,0.2)', outlineOffset: '3px' }}
            >
              <span className="text-xs tracking-[0.3em] uppercase font-mono">Маршрут на карте</span>
              <i className="ri-map-pin-line text-base group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
